import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
import Decimal from 'decimal.js';

export interface SplitAmount {
  num: string;
  unit: string;
  numInt: number;
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// 分割金额  console.log(splitAmount("200 万元"));   // { num: "200", unit: "万" }
export interface SplitAmount {
  num: string; // 原始数字（字符串）
  unit: string; // 单位（万/亿/次等）
  numInt: number; // 转成整数（如果能转）
}

export function splitAmount(str: string): SplitAmount {
  // 去掉空格
  str = (str || '').trim();

  // 匹配数字 + 单位（可选），单位不限（忽略“元”）
  // 例子: "200万", "3次", "100元", "1,000亿"
  const match = str.match(/^([\d,.]+)\s*([^\d元]?)元?$/);

  if (match) {
    return {
      num: match[1].replace(/,/g, ''), // 去掉千分位逗号
      unit: match[2] || '', // 单位（万、亿、次等）
      numInt: parseInt(match[1].replace(/,/g, ''), 10)
    };
  }

  // 默认返回
  return { num: str, unit: '', numInt: 0 };
}

export function extractNumber(str: string): string | null {
  const match = str.match(/(\d+(?:\.\d+)?)/);
  return match ? match[1] : null;
}

// 乘以100
export function times100(num: number | string, times: number = 100) {
  return new Decimal(num).times(times);
}
